function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["event"];
function cov_24cc96m0xy() {
  var path = "/app/src/hooks/use-analytics.ts";
  var hash = "08f6f3b07b0bff877146160639df3d89044be6b0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/hooks/use-analytics.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 28
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "1": {
        start: {
          line: 10,
          column: 42
        },
        end: {
          line: 10,
          column: 57
        }
      },
      "2": {
        start: {
          line: 12,
          column: 49
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "3": {
        start: {
          line: 13,
          column: 11
        },
        end: {
          line: 19,
          column: 5
        }
      },
      "4": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 32,
          column: 4
        }
      },
      "5": {
        start: {
          line: 25,
          column: 33
        },
        end: {
          line: 25,
          column: 70
        }
      },
      "6": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 60
        }
      },
      "7": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 57
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 28
          },
          end: {
            line: 9,
            column: 29
          }
        },
        loc: {
          start: {
            line: 9,
            column: 34
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 13,
            column: 5
          }
        },
        loc: {
          start: {
            line: 13,
            column: 11
          },
          end: {
            line: 19,
            column: 5
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 24,
            column: 5
          }
        },
        loc: {
          start: {
            line: 24,
            column: 52
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 24
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "08f6f3b07b0bff877146160639df3d89044be6b0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_24cc96m0xy = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_24cc96m0xy();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useCallback, useMemo } from 'react';
import { useAppContext } from 'src/context/store/app-provider';
import { dataDog } from 'src/utils/datadog/data-dog';
import { getDeviceType } from 'src/utils/get-device-type';
import { getSourcePlugin } from 'src/utils/get-source-plugin';
import { sendSegmentEvent } from 'src/utils/send-segment-event';
cov_24cc96m0xy().s[0]++;
export var useAnalytics = function useAnalytics() {
  cov_24cc96m0xy().f[0]++;
  var _ref = (cov_24cc96m0xy().s[1]++, useAppContext()),
    merchantCode = _ref.merchantCode,
    aid = _ref.aid,
    entityId = _ref.entityId;
  var globalProps = (cov_24cc96m0xy().s[2]++, useMemo(function () {
    cov_24cc96m0xy().f[1]++;
    cov_24cc96m0xy().s[3]++;
    return {
      merchantCode: merchantCode,
      platformType: getDeviceType(),
      productType: 'installments',
      merchantId: aid,
      sourcePlugin: getSourcePlugin()
    };
  }, [merchantCode, aid]));
  cov_24cc96m0xy().s[4]++;
  return useCallback(function (_ref2) {
    var event = _ref2.event,
      restProperties = _objectWithoutProperties(_ref2, _excluded);
    cov_24cc96m0xy().f[2]++;
    var analyticProperties = (cov_24cc96m0xy().s[5]++, _objectSpread(_objectSpread({}, globalProps), restProperties));
    cov_24cc96m0xy().s[6]++;
    sendSegmentEvent(event, entityId, analyticProperties);
    cov_24cc96m0xy().s[7]++;
    dataDog.info('segment', event, analyticProperties); // logs all analytics events to DD
  }, [globalProps, entityId]);
};